import GrayHeaderCard from "../../../../components/ui/cards/gray-header-card/GrayHeaderCard";
import {useState} from "react";
import {Button, FormControl, InputLabel, Typography} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {Search} from "@material-ui/icons";
import InlineRadioButtons from "../../../../components/ui/inputs/radio-buttons/inline-radio-buttons/InlineRadioButtons";
import {
    useSoglieFilterStyles
} from "../../../../components/mobile/sub-menu-items/soglie-eventi/soglie/soglie-filter/SoglieFilterStyles";
import {
    filterRadioButtons
} from "../../../../components/mobile/sub-menu-items/soglie-eventi/soglie/associate-remove-sim-modal/AssociateRemoveSimModalHelper";
import PropTypes from "prop-types";
import FilterDialog from "./filter-dialog/FilterDialog";
import FilterDialogContratto from "./filter-dialog-contratto/FilterDialogContratto";

const SimClientSideFilter = (props) => {
    const classes = useSoglieFilterStyles()
    const [searchText, setSearchText] = useState("")
    const [selectedRadioBtn, setSelectedRadioBtn] = useState(filterRadioButtons[0].value)
    const [openFilterDialog, setOpenFilterDialog] = useState(false)

    const getTitle = (<Typography variant="subtitle2">Ricerca</Typography>)

    const handleInputChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleEnterPressed = (e) => {
        if (e.which === 13)
            handleSearchIcon()
    }

    const handleSearchIcon = () => {
        if (searchText.length !== 0) {
            props.handleSearchIcon(selectedRadioBtn, searchText)
            setSearchText("");
        }
    }

    const handleRadioBtnChange = (e) => {
        setSelectedRadioBtn(e.target.value)
    }

    const handleClickOpenFilterDialog = () => {
        setOpenFilterDialog(true);
    }

    return (
        <>
            <GrayHeaderCard title={getTitle}
                            elevation={3}>
                <>
                    <Grid container
                          justifyContent="space-between"
                          alignItems="center">
                        <Grid item container
                              alignItems="center"
                              xs={12} sm={8} md={9}>
                            <FormControl fullWidth>
                                <InputLabel>{props.cercaText}</InputLabel>
                                <Input labelid="filterSearchLabel"
                                       type="search"
                                       autoComplete="off"
                                       onChange={handleInputChange}
                                       value={searchText}
                                       onKeyDown={handleEnterPressed}
                                       endAdornment={
                                           <InputAdornment position="end">
                                               <IconButton onClick={handleSearchIcon}>
                                                   <Search/>
                                               </IconButton>
                                           </InputAdornment>
                                       }/>
                            </FormControl>

                            <Typography variant="subtitle2"
                                        display="inline"
                                        className={classes.typographyRadioButtons}
                                        color="textSecondary">
                                Cerca per
                            </Typography>

                            <InlineRadioButtons value={selectedRadioBtn}
                                                radioButtons={filterRadioButtons}
                                                handleChange={handleRadioBtnChange}/>
                        </Grid>

                        {props.showFilterButton ? <Grid item container
                                                        justifyContent="flex-end"
                                                        xs={12} sm={4} md={3}>
                            <Button variant="outlined"
                                    color="primary"
                                    className={classes.filterBtn}
                                    onClick={handleClickOpenFilterDialog}>
                                Filtri
                            </Button>
                        </Grid> : null}
                    </Grid>
                </>
            </GrayHeaderCard>

            {openFilterDialog && !props.isFromContratto ?
                <FilterDialog open={openFilterDialog}
                              handleFilterSearch={props.handleSelectSearch}
                              filter={props.filter}
                              handleDialogClose={() => setOpenFilterDialog(false)}/> : null}
            {openFilterDialog && props.isFromContratto ?
                <FilterDialogContratto open={openFilterDialog}
                                       isOption={props.isOption}
                                       arePianoDetails={props.arePianoDetails}
                                       handleFilterSearch={props.handleSelectSearch}
                                       isExtraShare={props.isExtraShare}
                                       filter={props.filter}
                                       handleDialogClose={() => setOpenFilterDialog(false)}/> : null}
        </>
    )
}

SimClientSideFilter.propTypes = {
    handleSearchIcon: PropTypes.func.isRequired,
    handleSelectSearch: PropTypes.func.isRequired,
    filter: PropTypes.shape({
        tags: PropTypes.shape({value: PropTypes.array.isRequired}).isRequired,
        seriale: PropTypes.shape({value: (PropTypes.oneOfType([PropTypes.array, PropTypes.string]))}).isRequired,
        numeroDiTelefono: PropTypes.shape({value: (PropTypes.oneOfType([PropTypes.array, PropTypes.string]))}).isRequired,
        piano: PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        }),
        tipologiaSim: PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })
    }).isRequired,
    showFilterButton: PropTypes.bool,
    cercaText: PropTypes.string
}

SimClientSideFilter.defaultProps = {
    showFilterButton: true,
    cercaText: 'Cerca'
}

export default SimClientSideFilter
